module.exports = __webpack_public_path__ + "static/media/starshipit4.13f5ad23.jpg";